
import { FloatingFeature } from "@models";
/**
 * Triggers a reroll of damage dice 
 * when they roll below a threshold
 * 
 */
export class Reroll extends FloatingFeature {
  threshold = 1;
  allowed_damage_types: string[] = ["ALL"];
  allowed_armor_types: string[] = ["ALL"];
  required_armor_types: string[] = ["None"];
  excluded_weapon_keywords: string[] = ["None"];
  required_weapon_keywords: string[] = ["None"];

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.threshold = obj.threshold ? obj.threshold : 1;
      this.allowed_damage_types = obj.allowed_damage_types ? [...obj.allowed_damage_types] : ["ALL"];
      this.allowed_armor_types = obj.allowed_armor_types ? [...obj.allowed_armor_types] : ["ALL"];
      this.required_armor_types = obj.required_armor_types ? [...obj.required_armor_types] : ["None"];
      this.excluded_weapon_keywords = obj.excluded_weapon_keywords ? [...obj.excluded_weapon_keywords] : ["None"];
      this.required_weapon_keywords = obj.required_weapon_keywords ? [...obj.required_weapon_keywords] : ["None"];
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.threshold = obj.threshold ? obj.threshold : 1;
  //     this.allowed_damage_types = obj.allowed_damage_types ? [...obj.allowed_damage_types] : ["ALL"];
  //     this.allowed_armor_types = obj.allowed_armor_types ? [...obj.allowed_armor_types] : ["ALL"];
  //     this.required_armor_types = obj.required_armor_types ? [...obj.required_armor_types] : ["None"];
  //     this.excluded_weapon_keywords = obj.excluded_weapon_keywords ? [...obj.excluded_weapon_keywords] : ["None"];
  //     this.required_weapon_keywords = obj.required_weapon_keywords ? [...obj.required_weapon_keywords] : ["None"];
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      threshold: this.threshold,
      allowed_damage_types: this.allowed_damage_types,
      allowed_armor_types: this.allowed_armor_types,
      required_armor_types: this.required_armor_types,
      excluded_weapon_keywords: this.excluded_weapon_keywords,
      required_weapon_keywords: this.required_weapon_keywords
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof Reroll) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: Reroll) {
    this.threshold = copyMe.threshold;
    this.allowed_armor_types = [...copyMe.allowed_armor_types];
    this.allowed_damage_types = [...copyMe.allowed_damage_types];
    this.required_armor_types = [...copyMe.required_armor_types];
    this.excluded_weapon_keywords = [...copyMe.excluded_weapon_keywords];
    this.required_weapon_keywords = [...copyMe.required_weapon_keywords];
  }

  clone(drop_ids = false): Reroll {
    const new_obj = new Reroll();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}